import { Icon, IconName } from '@packages/shared-ui';
import type { ComponentProps } from 'react';

import { useStyles } from './Radio.styles';

type RadioProps = {
  ref?: React.Ref<HTMLInputElement>;
  isOnDark?: boolean;
} & ComponentProps<'input'>;

export function Radio({
  ref,
  isOnDark = false,
  className,
  disabled,
  children,
  ...inputProps
}: RadioProps) {
  const { classes, cx } = useStyles({ isOnDark });

  return (
    <label
      className={cx(classes.root, disabled && classes.disabled, className)}
    >
      <input
        ref={ref}
        type='radio'
        className={classes.input}
        disabled={disabled}
        {...inputProps}
      />
      <span className={classes.icon} data-radio-icon-wrapper>
        <span className={classes.checkedIcon} data-radio-icon='checked'>
          <Icon name={IconName.RADIO_CHECKED} />
        </span>
        <span className={classes.uncheckedIcon} data-radio-icon='unchecked'>
          <Icon name={IconName.RADIO_UNCHECKED} />
        </span>
      </span>
      {children}
    </label>
  );
}
